// Pro API - Room Operations
import { request } from "../base";
import type { Room } from "./types";

export const roomsApi = {
	async list(proId: string, projectId: string) {
		return request<Room[]>(
			`/api/pro/${proId}/projects/${projectId}/rooms`,
		);
	},

	async get(proId: string, roomId: number) {
		return request<Room>(`/api/pro/${proId}/rooms/${roomId}`);
	},

	async create(
		proId: string,
		projectId: string,
		data: {
			roomType: string;
			name?: string;
			areaSqft?: number;
			budgetSpent?: string;
			materials?: string[];
			styleTags?: string[];
		},
	) {
		return request<Room>(
			`/api/pro/${proId}/projects/${projectId}/rooms`,
			{
				method: "POST",
				body: data,
			},
		);
	},

	async update(
		proId: string,
		roomId: number,
		data: Partial<{
			roomType: string;
			name: string;
			areaSqft: number;
			budgetSpent: string;
			materials: string[];
			styleTags: string[];
		}>,
	) {
		return request<Room>(`/api/pro/${proId}/rooms/${roomId}`, {
			method: "PUT",
			body: data,
		});
	},

	async delete(proId: string, roomId: number) {
		return request(`/api/pro/${proId}/rooms/${roomId}`, {
			method: "DELETE",
		});
	},

	async reorder(proId: string, projectId: string, roomIds: number[]) {
		return request(
			`/api/pro/${proId}/projects/${projectId}/rooms/reorder`,
			{
				method: "POST",
				body: { roomIds },
			},
		);
	},

	async setDefault(proId: string, projectId: string, roomId: number) {
		return request(
			`/api/pro/${proId}/projects/${projectId}/default-room`,
			{
				method: "PUT",
				body: { roomId },
			},
		);
	},
};
